function ca_formInputsFocusIn( form ) {

    form.querySelectorAll('input[type="text"], input[type="tel"], textarea').forEach(item => {
        item.addEventListener('focusin', event => {
        
            if (item.classList.contains('error-color') ) {

                item.parentNode.previousElementSibling.classList.remove('error-color'); // label
                item.classList.remove('error-color'); // input
                item.nextElementSibling.classList.remove('error-corner-label'); // corner
                item.nextElementSibling.nextElementSibling.style.display='none'; // message

            }
           
        });
    });
}

function ca_showHide( el, delay, scale ) {

    // Show an element and hide it after a delay
    // CSS Prerequisites: el => display: none, opacity: 0, transform: scale(0)

    new Promise( (resolve, reject) =>{

        el.style.display="block";

        // offsetParent => returns null if the element or its parent element has the display property set to none.

        // Window.getComputedStyle() => returns an object containing the values of all CSS properties of an element, after applying active stylesheets and resolving any basic computation those values may contain.

        if (el.offsetParent !== null && window.getComputedStyle(el, null).display === 'block' ) {

            resolve();

        }
        
    }).then( () =>{ 

        el.addEventListener('transitionend', () => {

            setTimeout( ()=> { 
                    
                el.style.opacity="0";
                el.style.display='none';
                if (scale) { el.style.transform="scale(0)"; }
                
            }, delay);

        });
    
    }).then ( () => {

        el.style.opacity="1";
        if (scale) { el.style.transform="scale(1)"; }

    });                               

}

function addRemoveErrorClass( field, msg, addRemove ) {

    const corner = document.querySelector(field + ' .corner-label'),
          errMsgDiv = document.querySelector(field + ' .error'),
          errWrapper = document.querySelector(field + ' .err-wrapper'),
          toApply = document.querySelectorAll(field + ' label, ' + field + ' input, ' + field + ' textarea');

    for ( let i = 0; i < toApply.length; i++ ) {

        if ( addRemove ) { toApply[i].classList.add( "error-color" ); } else { toApply[i].classList.remove( "error-color" ); }

    }

    if ( addRemove ) {     

        corner.classList.add('error-corner-label');
        errMsgDiv.innerHTML=msg;
        errWrapper.style.display='block';

    } else {
  
        corner.classList.remove('error-corner-label');
        errMsgDiv.innerHTML='';
        errWrapper.style.display='none';
        
    }
}
